import { render, staticRenderFns } from "./ages_pyramid.vue?vue&type=template&id=09b3f4fa&scoped=true&lang=pug&"
import script from "./ages_pyramid.vue?vue&type=script&lang=coffee&"
export * from "./ages_pyramid.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3f4fa",
  null
  
)

export default component.exports